(function($) {
	formHelper.addRule({
		form: '.form-manage-installation-dropdowns',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			}
		}
	});
})(jQuery);

// Military Installations
jQuery(function initToolsManageInstallationMilitaryResults($) {
	$('.manage-installation-military-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-installation-military-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initInstallationMilitaryEdit($) {
	$('.edit-installation-military-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-installation-military');
		var $submitBtn             = $container.find('.btn-submit');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-installation-military').val('no');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
				$('#delete-installation').val('yes');
				$form.submit();
			}
		});
	});
});

// Veteran Installations
jQuery(function initToolsManageInstallationVeteranResults($) {
	$('.manage-installation-veteran-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-installation-veteran-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initInstallationVeteranEdit($) {
	$('.edit-installation-veteran-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-installation-veteran');
		var $submitBtn             = $container.find('.btn-submit');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-installation-veteran').val('no');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
				$('#delete-installation').val('yes');
				$form.submit();
			}
		});
	});
});

// Heroes Installations
jQuery(function initToolsManageInstallationHeroesResults($) {
	$('.manage-installation-heroes-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-installation-heroes-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initInstallationHeroesEdit($) {
	$('.edit-installation-heroes-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-installation-heroes');
		var $submitBtn             = $container.find('.btn-submit');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-installation-heroes').val('no');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
				$('#delete-installation').val('yes');
				$form.submit();
			}
		});
	});
});

jQuery(function($){
	$('.js-installation-dropdown-actions').change(function() {
		if($(this).val() !== '') {
			document.location.href = $(this).val();
		}
	});
});